// extracted by mini-css-extract-plugin
module.exports = {"list":"TimesList_list__2-KjH","day":"TimesList_day__3-HW9","bold":"TimesList_bold__35pj-","devider":"TimesList_devider__1eEuo"};